import * as types from "./types";

const mutations = {
  ["BillTrend"](state, payload) {
    Object.assign(state, { billData: payload });
  },
  ["DailyUsage"](state, payload) {
    Object.assign(state, { dailyUsage: payload });
  },
  [types.LOGOUT](state) {
    Object.assign(state, { isLogin: false, user: {} });
  },
  [types.SET_USER_DETAIL](state, payload) {
    Object.assign(state, { userDetails: payload });
  },
  ["InvoiceList"](state, payload) {
    Object.assign(state, { invoiceList: payload });
  },

  // MANAGE SERVICE
  ["manageServiceList"](state, payload) {
    Object.assign(state, { manageList: payload });
  },

  //TOPUP
  ["topupList"](state, payload) {
    Object.assign(state, { dataTopupList: payload });
  },
  ["PaymentList"](state, payload) {
    Object.assign(state, { paymentList: payload });
  },
  ["TransactionList"](state, payload) {
    Object.assign(state, { transactionList: payload });
  },
  ["TicketList"](state, payload) {
    Object.assign(state, { ticketList: payload });
  },
  [types.SET_VIEW_BILL_DETAIL](state, payload) {
    Object.assign(state, { billDetail: payload });
  },

  //HELP
  [types.SET_TICKET_TEMPLATE](state, payload) {
    Object.assign(state, { ticketTemplate: payload });
  },
  [types.SET_USER_BY_TEAM](state, payload) {
    Object.assign(state, { teamUsers: payload });
  },
  [types.SET_TICKET_BY_ID](state, payload) {
    Object.assign(state, { ticketById: payload });
  },
  ["InvoList"](state, payload) {
    Object.assign(state, { InvoList: payload });
  }
};

export default mutations;
